export default {
  CREATE_CALENDAR: 'CREATE_CALENDAR',
  RESET_DATA: 'RESET_DATA'
}